import { createImmutableSelector } from './utils';
export const getAuth = state => state.auth;
export const getUserId = createImmutableSelector([getAuth], auth => auth.user.user_id);
export const getUserEmail = createImmutableSelector([getAuth], auth => auth.user.email);
export const getScopes = createImmutableSelector([getAuth], auth => auth.user.scopes);
export const getLimits = createImmutableSelector([getAuth], auth => auth.portal.limits);